<template>
  <div
    style="width: 100%"
    :class="$vuetify.breakpoint.width < 960 ? 'ml-0' : !$store.getters.selectedWsInfo ? 'ml-0' : 'ml-3'"
  >
    <v-row
      no-gutters
      justify="center"
      align="center"
      :class="
        $store.getters.selectedWsInfo
          ? $vuetify.breakpoint.width < 1264
            ? $vuetify.breakpoint.width < 960
              ? 'ml-8'
              : 'ml-6'
            : 'ml-3'
          : 'ml-0'
      "
      style="color: white"
    >
      <h1 v-if="!$store.getters.selectedWsInfo" @click="goMain" :class="title ? 'logo' : 'logo mr-2'">
        <span v-if="$vuetify.breakpoint.width >= 960">Tape</span>
      </h1>
      <span v-if="!$store.getters.selectedWsInfo && title" class="ml-2" style="font-size: 16px; color: #96a7af">|</span>
      <v-col
        :cols="$vuetify.breakpoint.width < 1264 ? ($vuetify.breakpoint.width < 500 ? 'auto' : 'auto') : 'auto'"
        :style="isMobile ? 'margin-right: -10px; position: relative' : 'position: relative'"
        class="text-truncate"
      >
        <!-- Channel Title -->
        <span
          v-if="
            ($route.name.indexOf('MeetingList') > -1 ||
              $route.name === 'Channel' ||
              computedSelectedCh['chCategory'] === 'inbox' ||
              $route.name === 'Assigned') &&
            $route.name.indexOf('ChannelMeeting') < 0 &&
            $store.getters.selectedWsInfo
          "
          :class="$vuetify.breakpoint.width < 960 ? 'ml-1' : 'ml-3'"
          :style="
            $vuetify.breakpoint.width < 960
              ? 'color: #eee; font-size: 13px; font-weight: 500'
              : 'color: #eee; font-size: 16px; font-weight: 500'
          "
        >
          {{
            $route.name === 'Assigned'
              ? 'Assigned To Me'
              : computedSelectedCh['chCategory'] === 'inbox'
              ? inboxFolderTitle
              : folder
          }}
        </span>
        <span
          v-if="
            (title && title !== null && title !== '' && $route.name.indexOf('MeetingList') > -1) ||
            ($route.name === 'Channel' && computedSelectedCh['chCategory'] !== 'inbox' && title)
          "
          :style="
            $vuetify.breakpoint.width < 960
              ? 'color: #96a7af; font-size: 13px; margin-right: 8px; margin-left: 8px; font-weight: 500'
              : 'color: #96a7af; font-size: 16px; margin-right: 8px; margin-left: 8px; font-weight: 500'
          "
        >
          /
        </span>
        <span
          v-if="($route.name.indexOf('MeetingList') > -1 || $route.name === 'Channel') && title"
          :style="
            $vuetify.breakpoint.width < 960
              ? 'color: white; font-size: 13px; margin-right: 8px; font-weight: 500'
              : 'color: white; font-size: 16px; margin-right: 8px; font-weight: 500'
          "
        >
          {{ title }}
        </span>

        <!-- Meeting Title -->
        <span id="hide" ref="hide"></span>
        <v-tooltip v-if="mtInfo" bottom nudge-top="10" :color="titleTooltip ? '#131b1e' : 'transparent'">
          <template v-slot:activator="{ on }">
            <v-text-field
              id="txt"
              v-if="mtInfo && $route.name.indexOf('ChannelMeeting') > -1"
              ref="txt"
              :class="isMtOrganizer ? 'txtf-meeting-title txtf-meeting-title-organizer' : 'txtf-meeting-title'"
              :readonly="userInfo ? mtCreatorInfo.userId != userInfo.userId : true"
              v-model="mtInfo.mtTopic"
              hide-details
              @focus="titleTooltip === false"
              @blur="outFocus"
              @keyup.enter="outFocus"
              flat
              solo
              dark
              autocomplete="off"
              placeholder="Untitled"
              v-on="on"
            ></v-text-field>
          </template>
          <span v-if="titleTooltip">{{ mtInfo.mtTopic ? mtInfo.mtTopic : 'Untitled' }}</span>
        </v-tooltip>
      </v-col>

      <!-- Meeting Dialog start -->
      <v-dialog v-model="dialog" fullscreen persistent no-click-animation transition="dialog-top-transition">
        <template v-slot:activator="{ on, attrs }">
          <span v-on="on" v-bind="attrs" style="max-width: 400px">
            <!-- <v-btn v-if="$route.name.indexOf('ChannelMeeting') > -1" plain width="34" style="min-width: 0">
              <span id="header-btn-dropdown" class="material-icons-round md-36 white--text" translate="no">
                arrow_drop_down
              </span>
            </v-btn> -->
          </span>
          <span
            v-show="$route.name.indexOf('ChannelMeeting') > -1 && isEnded && $vuetify.breakpoint.width >= 960"
            class="label-end"
          >
            {{ $t('ended') }}
          </span>
        </template>
        <v-card color="rgba(33, 52, 59, 0.9)" class="px-6">
          <v-toolbar dark color="rgba(33, 52, 59, 0.9)" elevation="0">
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn plain dark @click.stop="dialog = !dialog">
                <span class="material-icons-round" style="font-size: 18px" translate="no">close</span>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <div class="mb-1 mx-10">
            <span v-if="mtInfo" style="position: relative; color: white; font-size: 40px">
              <span v-show="isEnded" class="label-end-dialog">{{ $t('ended') }}</span>
              <v-text-field
                ref="meetingtitle"
                :readonly="!isMtOrganizer"
                v-model="mtInfo.mtTopic"
                :placeholder="mtInfo.mtTopic ? mtInfo.mtTopic : 'Untitled'"
                :style="isMtOrganizer ? 'cursor: text' : 'cursor: default'"
                class="mb-1 txtf-meeting-title in-dialog"
                hide-details
                @blur="outFocus"
                @keyup.enter="outFocus"
                flat
                solo
                dark
              ></v-text-field>
            </span>
            <div
              v-if="mtInfo && sectionIndex != null"
              :class="$vuetify.breakpoint.width < 960 ? 'd-flex ml-0 mb-5' : 'd-flex ml-3 mb-5'"
              style="font-size: 12px; color: #96a7af; align-items: center"
            >
              <v-icon color="#96a7af" class="mr-2">mdi-vhs</v-icon>
              <span style="vertical-align: middle">{{ mtInfo.mtClipCount }} Clips</span>
              <span style="vertical-align: middle" class="mx-2">|</span>
              <span style="vertical-align: middle">Total {{ duration }}</span>
            </div>
          </div>

          <v-row
            :class="
              $vuetify.breakpoint.width < 960
                ? 'container-tag d-flex flex-nowrap mb-5 mx-10'
                : 'container-tag d-flex flex-nowrap mb-5 mx-15'
            "
            no-gutters
            align="center"
            justify="start"
          >
            <v-col xl="auto" lg="auto" md="auto" sm="auto" cols="auto" style="align-self: flex-start">
              <span
                :style="
                  $vuetify.breakpoint.width < 960
                    ? 'margin-right: 8px; font-size: 12px'
                    : 'margin-right: 10px; font-size: 14px'
                "
              >
                <v-icon
                  class="mt-1"
                  color="#96a7af"
                  :style="
                    $vuetify.breakpoint.width < 960
                      ? 'position: relative; top: 0px; font-size: 20px !important'
                      : 'position: relative; top: 2px'
                  "
                >
                  mdi-tag
                </v-icon>
              </span>
            </v-col>
            <v-col v-if="mtInfo" cols="11">
              <v-chip
                v-if="isPublic"
                :style="$vuetify.breakpoint.width < 960 ? 'font-size: 12px; height: 24px' : 'height: 28px'"
                class="ma-1"
                color="#0062FF"
                text-color="white"
                @click:close="deleteTag()"
              >
                PublicAccess
              </v-chip>
              <transition-group name="fade">
                <v-chip
                  small
                  :key="tag"
                  v-for="(tag, i) in mtInfo.mtHashTag"
                  class="ma-1"
                  :close="isMtOrganizer"
                  color="#4d5d62"
                  style="height: 28px"
                  text-color="#ddd"
                  @click:close="deleteTag(i)"
                >
                  {{ tag }}
                </v-chip>
              </transition-group>
              <el-input
                type="text"
                size="mini"
                :style="
                  $vuetify.breakpoint.width < 960
                    ? 'width: 100px; margin: 0 5px 0 8px; font-size: 12px !important'
                    : 'width: 100px; margin: 0 5px 0 8px'
                "
                v-model="newTag"
                v-if="isAddTag"
                @blur="addTag"
                @focusout.native="isAddTag = false"
                v-on:keyup.native.enter="addTag"
                maxlength="25"
              />
              <v-btn
                v-if="isMtOrganizer"
                color="white2"
                @click="isAddTag = true"
                class="ml-2 black3--text"
                :height="$vuetify.breakpoint.width < 960 ? '24' : '26'"
              >
                {{ $t('addTags') }}
              </v-btn>
            </v-col>
          </v-row>

          <div v-if="mtInfo" :class="$vuetify.breakpoint.width < 960 ? 'mt-10 ml-10' : 'mt-10 ml-15'">
            <div v-for="item in mtInfo.sectionInfo" :key="item.stId" style="" class="mt-7 ml-5">
              <v-divider dark class="mb-10 mr-15"></v-divider>
              <div
                @click="selectSection(item.stOrder)"
                class="section-title-in-dialog"
                v-text="item.stTitle ? item.stTitle : 'Untitled'"
              ></div>
            </div>
            <v-btn
              class="btn-add-section mt-7 ml-5"
              :loading="isAddLoading"
              @click="addNewSection"
              elevation="0"
              color="gray"
            >
              {{ 'Add New Section' }}
            </v-btn>
          </div>

          <div
            :style="
              $vuetify.breakpoint.width < 960
                ? 'position: fixed; bottom: 60px; right: 20px'
                : 'position: fixed; bottom: 60px; left: 60px'
            "
          >
            <v-btn
              width="160"
              v-if="
                sectionIndex != null &&
                ((userInfo ? mtCreatorInfo.userId === userInfo.userId : false) ||
                  isMtOrganizer ||
                  isWsOwner ||
                  isWsManager)
              "
              color="rgb(255, 87, 95)"
              class="white1--text"
              style="margin-left: 15px"
              @click="openDialog('Delete')"
            >
              {{ $t('delete') + ' This Meeting' }}
            </v-btn>
            <v-tooltip top color="#131b1e">
              <template v-slot:activator="{ on }">
                <div v-on="on" style="display: inline-block">
                  <v-btn
                    :loading="isEndedLoading"
                    width="60"
                    style="margin-left: 10px"
                    color="achromaticBase"
                    class="white1--text"
                    v-if="
                      sectionIndex != null &&
                      ((userInfo ? mtCreatorInfo.userId === userInfo.userId : false) ||
                        isMtOrganizer ||
                        isWsOwner ||
                        isWsManager)
                    "
                    @click="setMtUpdate(true)"
                  >
                    {{ isEnded ? $t('restart') : $t('end') }}
                  </v-btn>
                </div>
              </template>
              <span>{{ isEnded ? 'This will unblock uploading clips' : 'This will block uploading clips' }}</span>
            </v-tooltip>
            <v-btn
              color="#289067"
              width="70"
              style="margin-left: 10px"
              class="white1--text"
              v-if="sectionIndex != null"
              @click="openDialog('Share')"
            >
              {{ $t('share') }}
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
      <!-- Meeting Dialog end -->

      <!-- info start -->
      <v-col
        v-if="mtInfo && sectionIndex != null && $route.name.indexOf('ChannelMeeting') > -1"
        class="d-none d-lg-inline-block"
        style="font-size: 12px; color: #96a7af; align-items: center"
        cols="auto"
      >
        <v-tooltip bottom color="#131b1e">
          <template v-slot:activator="{ on }">
            <span
              v-show="isPublic"
              v-on="on"
              class="material-icons-round ml-2"
              style="font-size: 20px; vertical-align: middle; cursor: default"
              translate="no"
            >
              public
            </span>
          </template>
          <span>This meeting can be accessed by anyone with the URL.</span>
        </v-tooltip>
      </v-col>
      <v-col
        v-if="mtInfo && sectionIndex != null && $route.name.indexOf('ChannelMeeting') > -1"
        cols="auto"
        style="text-align: right"
        class="d-none d-md-flex container-avatar ml-4"
      >
        <attendee
          :mtCreatorUid="mtCreatorInfo.userId"
          :mtOrganizerUid="mtOrganizerUid"
          :list="attendeeList"
          :isAdd="false"
          size="25"
          border="rgb(33, 52, 59)"
          :deleteOrgarnizer="true"
        ></attendee>
      </v-col>
      <!-- info end -->
      <v-spacer />
      <!-- btn start -->
      <v-col cols="auto" align="center" class="menu-noti" style="display: flex; align-items: center">
        <div v-if="!isMobile" :key="componentKey">
          <div
            v-if="
              $store.getters.selectedWsInfo &&
              (computedSelectedCh.chType === 'P' || (selectedWsInfo && selectedWsInfo.memberType === 'manager'))
            "
          >
            <v-col
              class="pa-0"
              v-if="
                (title && title !== null && title !== '' && $route.name.indexOf('MeetingList') > -1) ||
                $route.name === 'Channel'
              "
            >
              <v-tooltip bottom nudge-right="8" color="#131b1e">
                <template v-slot:activator="{ on }">
                  <img
                    v-on="on"
                    v-show="!isSlackIntegrated"
                    @click="moveToSlackInstallPage"
                    :src="slackImg.connect"
                    :style="
                      $vuetify.breakpoint.width < 960
                        ? 'cursor: pointer; filter: opacity(0.4); margin-right: -10px'
                        : 'cursor: pointer; filter: opacity(0.4); margin-right: -20px'
                    "
                    :width="$vuetify.breakpoint.width < 960 ? '50px' : '70px'"
                  />
                </template>

                <span v-show="!isSlackIntegrated">
                  {{ 'Connect Slack Channel' }}
                </span>
              </v-tooltip>
              <v-tooltip bottom nudge-right="8" color="#131b1e">
                <template v-slot:activator="{ on }">
                  <img
                    v-on="on"
                    v-show="isSlackIntegrated"
                    @click="disconnectSlackIntegration"
                    :src="slackImg.disconnect"
                    style="cursor: pointer; margin-right: -20px"
                    width="70px"
                  />
                </template>
                <span v-show="isSlackIntegrated">
                  {{ 'Disconnect Slack Channel' }}
                </span>
              </v-tooltip>
            </v-col>
          </div>
          <div
            v-show="
              $store.getters.selectedWsInfo &&
              (computedSelectedCh.chType === 'W' || selectedWsInfo.memberType !== 'manager')
            "
          ></div>
        </div>

        <!-- dot menu start -->
        <v-menu
          v-if="
            ($route.name == 'ChannelMeeting' || $route.name == 'ChannelMeetingShare') &&
            ((userInfo ? mtCreatorInfo.userId === userInfo.userId : false) || isMtOrganizer || isWsOwner || isWsManager)
          "
          offset-y
          left
        >
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              dark
              plain
              :style="
                $vuetify.breakpoint.width < 960
                  ? 'font-size: 26px; width: 26px; min-width: 26px; padding: 0'
                  : 'font-size: 30px; width: 48px; min-width: 48px'
              "
              :color="menuData.iconColor"
              class="menu-txt-class"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>
                {{ menuData.menuIcon }}
              </v-icon>
            </v-btn>
          </template>
          <v-list :color="menuData.bgColor">
            <v-btn
              color="#289067"
              :width="isMobile ? 100 : 120"
              :height="isMobile ? 40 : 50"
              class="d-flex d-md-none white1--text"
              v-if="
                ((userInfo ? mtCreatorInfo.userId === userInfo.userId : false) ||
                  isMtOrganizer ||
                  isWsOwner ||
                  isWsManager) &&
                mtInfo &&
                sectionIndex != null
              "
              @click="openDialog('Share')"
              plain
            >
              {{ $t('share') }}
            </v-btn>
            <v-btn
              :width="isMobile ? 100 : 120"
              :height="isMobile ? 40 : 50"
              v-if="(isMtOrganizer || isWsOwner || isWsManager) && mtInfo && sectionIndex != null"
              color="#43535e"
              class="white1--text d-md-flex"
              @click="openDialog('MoveToMeeting')"
              plain
            >
              {{ 'Move to' }}
            </v-btn>
            <v-tooltip left color="#131b1e">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    :width="isMobile ? 100 : 120"
                    :height="isMobile ? 40 : 50"
                    v-if="
                      ((userInfo ? mtCreatorInfo.userId === userInfo.userId : false) ||
                        isMtOrganizer ||
                        isWsOwner ||
                        isWsManager) &&
                      mtInfo &&
                      sectionIndex != null
                    "
                    color="#43535e"
                    class="red--text d-md-flex"
                    @click="openDialog('Delete')"
                    plain
                  >
                    {{ $t('delete') }}
                  </v-btn>
                </div>
              </template>
              <span>{{ 'Delete this meeting' }}</span>
            </v-tooltip>
            <v-tooltip left color="#131b1e">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    :loading="isEndedLoading"
                    :width="isMobile ? 100 : 120"
                    :height="isMobile ? 40 : 50"
                    color="achromaticBase"
                    class="white1--text d-md-flex"
                    v-if="
                      ((userInfo ? mtCreatorInfo.userId === userInfo.userId : false) ||
                        isMtOrganizer ||
                        isWsOwner ||
                        isWsManager) &&
                      sectionIndex != null
                    "
                    @click="setMtUpdate(true)"
                    plain
                  >
                    {{ isEnded ? $t('restart') : $t('end') }}
                  </v-btn>
                </div>
              </template>
              <span>{{ isEnded ? 'This will unblock uploading clips' : 'This will block uploading clips' }}</span>
            </v-tooltip>
          </v-list>
        </v-menu>

        <v-menu v-if="!(isMtOrganizer || isWsOwner || isWsManager)" offset-y left>
          <template v-slot:activator="{ attrs, on }">
            <v-icon
              :style="
                $vuetify.breakpoint.width < 960
                  ? 'font-size: 30px; width: 30px; height: 30px;'
                  : 'font-size: 30px; width: 48px; height: 48px;'
              "
              :color="menuData.iconColor"
              class="menu-txt-class d-flex d-md-none"
              v-bind="attrs"
              v-on="on"
            >
              {{ menuData.menuIcon }}
            </v-icon>
          </template>
          <v-list :color="menuData.bgColor">
            <v-btn
              color="#289067"
              :width="$vuetify.breakpoint.width < 960 ? 100 : 120"
              :height="$vuetify.breakpoint.width < 960 ? 40 : 50"
              class="d-flex d-md-none white1--text"
              @click="openDialog('Share')"
              plain
            >
              {{ $t('share') }}
            </v-btn>
          </v-list>
        </v-menu>
        <!-- dot menu end -->

        <v-tooltip bottom nudge-right="8" color="#131b1e">
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-btn
                color="#289067"
                width="70"
                height="32"
                class="d-none d-md-flex white1--text"
                v-if="sectionIndex != null && $route.name.indexOf('ChannelMeeting') > -1"
                @click="openDialog('Share')"
              >
                {{ $t('share') }}
              </v-btn>
            </div>
          </template>
          <span>{{ 'Share' }}</span>
        </v-tooltip>
        <v-tooltip bottom nudge-right="8" color="#131b1e">
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-btn
                plain
                color="achromaticBase"
                :width="$vuetify.breakpoint.width < 960 ? 28 : 30"
                :min-width="$vuetify.breakpoint.width < 960 ? 28 : 48"
                v-if="sectionIndex != null && $route.name.indexOf('ChannelMeeting') > -1"
                @click="copyUrlToClipboard"
                class="white1--text d-none d-md-flex"
              >
                <v-icon size="22">mdi-link-variant</v-icon>
              </v-btn>
            </div>
          </template>
          <span>{{ 'Copy Link' }}</span>
        </v-tooltip>

        <v-tooltip
          v-if="userInfo && computedWsClipCnt['planType'] !== 'Plus' && $vuetify.breakpoint.width > 700"
          bottom
          color="#131b1e"
        >
          <template v-slot:activator="{ on }">
            <div v-on="on" class="clip-cnt">
              <div
                :style="
                  userWsClipDuration >= wsLimitDuration * 0.85
                    ? userWsClipDuration >= wsLimitDuration
                      ? 'color: #ff575f'
                      : 'color: #ffc107'
                    : 'color: #ddd'
                "
              >
                {{ `${Math.floor(userWsClipDuration / 60)} / ${Math.floor(wsLimitDuration / 60)} mins` }}
              </div>
              <!-- <div style="padding-left: 3px">
                {{ ' / ' + Math.floor(wsLimitDuration / 60) + ' mins' }}
              </div> -->
            </div>
          </template>
          <span style="">
            {{ 'You can upload up to ' + Math.floor(wsLimitDuration / 60) + ' minutes in this workspace.' }}
          </span>
        </v-tooltip>

        <v-btn
          v-if="
            userInfo &&
            computedWsClipCnt['planType'] !== 'Plus' &&
            computedWsClipCnt['isWsMember'] &&
            userWsClipDuration >= 0 &&
            $vuetify.breakpoint.width > 700
          "
          class="btn-upgrade"
          dark
          @click="wsUpgrade"
        >
          Upgrade
        </v-btn>

        <v-menu
          class="overflow-y-auto"
          v-model="isOpened"
          offset-y
          max-height="600"
          :nudge-width="450"
          v-if="$store.getters.selectedWsInfo"
        >
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              icon
              color="#96A7AF"
              v-bind="attrs"
              v-on="on"
              :class="$vuetify.breakpoint.width < 960 ? 'mr-1' : ''"
              :width="$vuetify.breakpoint.width < 960 ? 36 : 48"
              :height="$vuetify.breakpoint.width < 960 ? 40 : 48"
            >
              <v-icon size="25">mdi-bell-outline</v-icon>
            </v-btn>
          </template>
          <v-card
            color="#31434f"
            v-scroll.self="onScroll"
            class="overflow-y-auto py-1"
            min-height="350"
            max-height="400"
          >
            <v-col v-for="item in notiList" :key="item.ntId" cols="12" style="padding: 8px 10px">
              <v-card color="#21343b" dark class="ml-1 mr-1">
                <v-list-item @click="movePage(item)">
                  <v-list-item-icon class="d-flex ma-4 ml-0">
                    <v-avatar
                      :color="!item.senderInfo ? getSenderName(item.senderInfo) : '' | iconBackground"
                      class="logo"
                      round
                    >
                      <span class="v-avatar-name-noti" v-if="!item.senderInfo || !item.senderInfo.userPicture">
                        {{ getSenderName(item.senderInfo) | iconFilter }}
                      </span>
                      <div class="avatar-bg" v-else>
                        <v-img :src="item.senderInfo.userPicture" v-if="item.senderInfo.userPicture" />
                      </div>
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-html="getContentText(item)" class="wrap-text alarm-title"></v-list-item-title>
                    <v-list-item-subtitle
                      v-text="calCreateAt(item.ntCreatedAt)"
                      class="wrap-text alarm-desc"
                      style="color: #96a7af"
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
            <empty-dialog
              v-if="isNotiEmpty && !isGetNoti"
              class="noti-empty"
              :body="$t('noNotification')"
            ></empty-dialog>
            <v-col v-if="isGetNoti && isNotiEmpty" align="center" :style="!isNotiEmpty ? '' : 'margin-top: 25%'">
              <v-progress-circular color="primary" :width="3" size="50" indeterminate></v-progress-circular>
            </v-col>
          </v-card>
        </v-menu>
        <v-avatar
          v-if="userInfo && userInfo.userStatus !== 'G'"
          :color="userName | iconBackground"
          class="logo"
          round
          size="25"
          @click="openDialog('Setting')"
          style="cursor: pointer"
        >
          <div class="avatar-bg" v-if="userInfo && userInfo.userPicture"></div>
          <span class="v-avatar-name-log" v-if="userInfo && !userInfo.userPicture">
            {{ userName | iconFilter }}
          </span>
          <v-img :src="userInfo && userInfo.userPicture" v-else />
        </v-avatar>
        <v-menu v-if="userInfo && userInfo.userStatus == 'G'" :key="'Large'" offset-y nudge-bottom="15">
          <template v-slot:activator="{ attrs, on }">
            <v-avatar
              v-bind="attrs"
              v-on="on"
              :color="userName | iconBackground"
              class="logo"
              round
              size="33"
              style="cursor: pointer"
            >
              <div class="avatar-bg" v-if="userInfo && userInfo.userPicture"></div>
              <v-img :src="userInfo && userInfo.userPicture" v-if="userInfo && userInfo.userPicture" />
              <span class="v-avatar-name-log" v-else>
                {{ userName | iconFilter }}
              </span>
            </v-avatar>
          </template>
          <v-card color="#31434f">
            <v-btn
              block
              style="background: #31434f; font-size: 16px; letter-spacing: 0; text-transform: none; color: white"
              height="50"
              @click="openDialog('EditName')"
            >
              {{ $t('editName') }}
            </v-btn>
            <v-btn
              block
              style="background: #31434f; font-size: 16px; letter-spacing: 0; text-transform: none; color: white"
              height="50"
              @click="setSignOut"
            >
              {{ $t('signOut') }}
            </v-btn>
          </v-card>
        </v-menu>
        <router-link v-if="!userInfo" tag="button" :to="{ name: 'SignIn' }" class="ml-4">
          <v-btn color="#289067" type="button" block elevation="0" height="32" class="d-none d-md-flex white1--text">
            {{ $t('tryForFree') }}
          </v-btn>
        </router-link>
      </v-col>
    </v-row>

    <share-dialog v-if="isShareDialog" @close="closeDialog" :isShareDialog.sync="isShareDialog"></share-dialog>
    <move-to-dialog
      v-if="isMoveToDialog"
      @close="closeDialog"
      :isMoveToDialog.sync="isMoveToDialog"
      :mtInfo.sync="$store.getters.currentMt"
    ></move-to-dialog>
    <meeting-delete-dialog
      v-if="mtInfo && sectionIndex != null"
      @close="closeDialog"
      :mtId="mtInfo.mtId"
      :isMtOrganizer.sync="isMtOrganizer"
      :isMeetingDeleteDialog.sync="isMeetingDeleteDialog"
    ></meeting-delete-dialog>
    <setting-dialog
      v-if="settingVisible"
      :settingVisible.sync="settingVisible"
      :menuType="settingMenuType"
      @openDialog="openDialog"
      @openManage="openDialog"
      @openSlot="openDialog"
      @close="closeDialog"
    ></setting-dialog>
    <editname-dialog
      v-if="isEditnameDialog"
      @close="closeDialog"
      :isEditnameDialog.sync="isEditnameDialog"
    ></editname-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getNotiList } from '@/services/notiApi'
import { setMtUpdate } from '@/services/meetingApi'
import EmptyDialog from '@/views/meeting/component/EmptyDialog'
import ShareDialog from '@/views/modal/ShareDialog'
import MeetingDeleteDialog from '@/views/modal/MeetingDeleteDialog'
import SettingDialog from '@/views/modal/SettingDialog'
import { mapActions } from 'vuex'
import { format, setDurationToTime, isMobile } from '@/common/lib/strLib'
import { copy } from '@/common/common'
import { getShareUrl, setUserFunnel } from '@/services/api'
import MoveToDialog from '@/views/modal/MoveToDialog'
import EditnameDialog from '@/views/modal/EditnameDialog'
import { isSafari } from '@/common/lib/strLib'
import { disconnectSlackIntegration } from '@/services/api'
import { setCreateSection } from '@/services/sectionApi'
import { setUpdateSection } from '@/services/sectionApi'
import Attendee from '@/views/meeting/component/card/Attendee'
import Toast from '@/views/meeting/component/Toast'

export default {
  name: 'SearchHeader',
  components: {
    Attendee,
    EmptyDialog,
    ShareDialog,
    MeetingDeleteDialog,
    MoveToDialog,
    SettingDialog,
    EditnameDialog,
  },
  data() {
    return {
      searchList: [],
      keyword: '',
      isOpened: false,
      path: '',
      tabData: {
        model: null,
        itemColor: '#31434f',
        bgColor: '#21343b',
        items: [
          { title: 'All', listType: 'ALL' },
          // { title: 'Inbox', listType: 'INBOX' },
        ],
      },
      notiList: [],
      isGetNoti: false,
      lastKey: null,
      isBottom: false,
      isFinish: false,
      settingVisible: false,
      isShareDialog: false,
      isSettingDialog: false,
      isMeetingDeleteDialog: false,
      isMoveToDialog: false,
      isEditnameDialog: false,
      isEnded: false,
      isEndedLoading: false,
      menuType: null,
      menuData: {
        menuIcon: 'mdi-dots-horizontal',
        iconColor: '#c4c4c4',
        bgColor: '#21343b',
      },
      duration: '0 sec',
      dialog: false,
      newTag: '',
      isAddTag: false,
      items: ['Streaming', 'Eating'],
      leaderAvatar: 'leaderAvatar',
      avatar: 'avatar',
      uniqueUploaders: 0,
      componentKey: 0,
      isAddLoading: false,
      slackImg: {
        disconnect: require('@/assets/img/Slack_Mark_Web.png'),
        connect: require('@/assets/img/Slack_Mark_Monochrome_White.png'),
      },
      titleTooltip: true,
      settingMenuType: '',
      // slackSvg: {
      //   disconnect: require('@/assets/img/Slack_Marks.svg'),
      //   connect: require('@/assets/img/Slack_Mark_Monochrome_Whites.svg'),
      // },
    }
  },
  created() {
    this.$root.$refs.SearchHeader = this

    if (this.$store.getters.selectedWsInfo) this.getNotiList('ALL')
    if (this.isSafari) this.setSafariUrl()
  },

  mounted() {
    // console.log('SearchHeader!!!!!!!!!!')

    if (document.getElementById('header-btn-dropdown')) document.getElementById('header-btn-dropdown').style.opacity = 1

    // if (this.mtInfo && this.mtInfo.mtTopic == '') {
    //   this.mtInfo.mtTopic = this.getUserName(this.mtCreatorInfo.userDisplayName || this.mtCreatorInfo.userFullName)
    // }
    if (this.mtInfo) {
      this.duration = setDurationToTime(this.mtInfo.mtClipDuration)
      let isEnded = this.mtInfo.isEnded
      if (this.mtInfo.isEnded !== undefined && this.mtInfo.isEnded !== null) this.isEnded = isEnded
    }
    const txt = document.getElementById('txt')
    this.resize()
    txt?.addEventListener('input', this.resize)

    if (this.mtInfo && this.mtInfo.mtClipCount === 0) {
      this.$nextTick(() => {
        if (
          (this.mtInfo.mtTopic.search('new Meeting') > -1 ||
            this.mtInfo.mtTopic.search('New Meeting') > -1 ||
            this.mtInfo.mtTopic === '') &&
          this.isMtOrganizer
        ) {
          // 미팅 타이틀 없으면 우선 포커싱
          this.$nextTick(() => {
            this.$refs.txt?.$refs.input.select(), 0
            this.titleTooltip = false
          })
        }
        // }
      })
    }
    document.addEventListener('keydown', this.keyEvent)
  },
  updated() {
    this.resize()
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keyEvent)
  },
  methods: {
    keyEvent(e) {
      if (
        !(e.target instanceof HTMLTextAreaElement) &&
        !(e.target instanceof HTMLInputElement) &&
        e.target.contentEditable !== 'true'
      ) {
        // S : share 다이얼로그 열기
        if (!e.ctrlKey && !e.metaKey && e.keyCode == 83) {
          this.openDialog('Share')
          e.preventDefault()
        }
      }
    },
    wsUpgrade() {
      this.settingMenuType = 'PLANBILLING'
      this.openDialog('Setting')
    },
    // getUserName(userName) {
    //   return userName.toLowerCase().charAt(userName.length - 1) === 's'
    //     ? `${userName}' New Meeting`
    //     : `${userName}'s New Meeting`
    // },
    goMain() {
      location.href = 'https://www.tape.ooo'
    },
    async addNewSection() {
      if (this.isSectionMt && this.userInfo && this.userInfo !== null && !this.mtInfo.isEnded) {
        try {
          this.isAddLoading = true
          let result = await setCreateSection(this, this.mtInfo.mtId, 'default', '', Date.now(), this.userInfo.userId)
          // let totalSectionList = this.totalSectionList
          // totalSectionList.push(result)
          // this.$store.dispatch('setTotalSectionList', totalSectionList)
          // await this.$store.dispatch('setSectionIndex', this.sectionList.length)
          await this.$store.dispatch('setAddSection', result)
          // if (!isMobile() && window.location.href.search('clipId') === -1 && !localStorage.getItem('stId')) {
          //   this.$nextTick(() => {
          //     setTimeout(() => {
          //       console.log('sectiontitle ', )
          //       this.$refs.sectiontitle ?? this.$refs.sectiontitle.$refs.input.focus(), 0
          //     })
          //   })
          // }
        } catch (error) {
          console.log(error)
        } finally {
          this.isAddLoading = false
          this.dialog = false
        }
      } else {
        // notify(this, 'This meeting has ended.', '', 'message')

        const content = {
          component: Toast,
          props: {
            msg: 'This meeting has ended.',
            // submsg: '',
          },
        }
        this.$toast.error(content)
      }
    },
    async updateStInfo(index) {
      try {
        await setUpdateSection(
          this,
          this.sectionList[index].stId,
          this.sectionList[index].mtId,
          this.sectionList[index].stTitle
        )
      } catch (error) {
        console.log(error)
      }
    },
    async moveToSlackInstallPage() {
      try {
        const wsId = this.selectedWsInfo ? this.selectedWsInfo.wsId ?? '' : ''
        let chId = this.computedSelectedCh['chId'] ?? ''
        chId = chId.includes('CH:') ? chId : 'CH:' + chId
        const redirectUrl = window.location.href

        let path = `https://slack.tape.ooo/install?wsId=${wsId}&chId=${chId}&redirectUrl=${redirectUrl}`

        // // private 일 경우 integration
        // if (chId.includes('my')) {
        //   path += `${this.userInfo.userId}`
        // }
        // // workspace 일 경우 integration
        // else if (chId.includes('general')) {
        //   path += `${wsId}`
        // }
        // // 일반 채널일 경우
        // else if (chId !== '') {
        //   path += `${chId}`
        // } else {
        //   console.log('wrong parameter ')
        //   return
        // }
        window.open(path, '_blank')
      } catch (error) {
        console.error(error)
      } finally {
        this.$store.dispatch('getChannelList', {
          wsId: this.selectedWsInfo.wsId,
        })
      }
    },

    async disconnectSlackIntegration() {
      try {
        //remove Slack Integration API GATEWAY

        let chId = this.computedSelectedCh['chId'] ?? ''
        this.$store.dispatch('setIsLoading', true)
        await disconnectSlackIntegration(this, this.selectedWsInfo.wsId, chId)
        this.$store.dispatch('getChannelList', {
          wsId: this.selectedWsInfo.wsId,
        })
      } catch (error) {
        console.error(error)
      } finally {
        this.$store.dispatch('setIsLoading', false)
      }
    },

    resize() {
      const hide = document.getElementById('hide')
      const txt = document.getElementById('txt')
      const txtParent = document.getElementById('txt') ? document.getElementById('txt').parentElement : ''

      // setTimeout(function () {
      if (txt && hide) {
        if (txt.value) {
          hide.textContent = txt?.value
          txt.style.width = hide?.getBoundingClientRect().width + 'px'
          if (txtParent) {
            txtParent.style.width = hide?.getBoundingClientRect().width + 'px'
            txtParent.style.maxWidth =
              window.innerWidth < 1263
                ? window.innerWidth < 959
                  ? window.innerWidth < 700
                    ? 'calc(100vw - 200px)'
                    : 'calc(100vw - 400px)'
                  : 'calc(100vw - 600px)'
                : 'calc(100vw - 700px)'
          }
        } else {
          hide.textContent = 'Untitled'
          txt.style.width = hide?.getBoundingClientRect().width + 'px'
          if (txtParent) {
            txtParent.style.width = hide?.getBoundingClientRect().width + 'px'
            txtParent.style.maxWidth =
              window.innerWidth < 1263
                ? window.innerWidth < 959
                  ? window.innerWidth < 700
                    ? 'calc(100vw - 200px)'
                    : 'calc(100vw - 400px)'
                  : 'calc(100vw - 600px)'
                : 'calc(100vw - 700px)'
          }
        }
      }
    },
    async setSafariUrl() {
      let title = this.mtInfo.mtTopic
      let imgUrl = this.mtInfo.mtThumbsUrl
      let routePayload = {
        name: 'ChannelMeetingShare',
        params: {
          wsDomain: this.$route.params['wsDomain'],
          chId: this.computedSelectedCh['chId'] ? this.computedSelectedCh['chId'].replace('CH:', '') : '',
          mtId: this.$route.params['mtId'],
        },
      }
      let linkUrl = location.origin + this.$router.resolve(routePayload).href
      let content = ''

      let copyUrl = await getShareUrl(this, title, content, imgUrl, linkUrl)

      this.safariPath = copyUrl.shortLink

      content = this.currentClip.clipNote
      if (this.currentClip.clipThumbsUrl) imgUrl = this.currentClip.clipThumbsUrl
      linkUrl += '?clipId=' + this.currentClip.clipId

      copyUrl = await getShareUrl(this, title, content, imgUrl, linkUrl)
      this.safariPathWithClipId = copyUrl.shortLink
    },
    async copyUrlToClipboard() {
      let copyResult
      let safariUrl = this.clipValue ? this.safariPathWithClipId : this.safariPath
      if (this.isSafari && this.safariUrl !== null) {
        copyResult = await copy(safariUrl)
      } else {
        await this.createShareUrl()
        copyResult = await copy(this.path)
      }

      if (copyResult) {
        this.checkFunnel()
        this.$store.dispatch('setFirebaseLog', {
          eventName: 'share',
          eventParam: {
            name: 'share',
            methodType: this.clipValue ? 'clip' : 'meeting',
          },
        })
        // if (!this.isMobile) notify(this, 'Success', this.$t('copiedClipboardUrl'), 'success')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('copiedClipboardUrl'),
            // submsg: 'Paste it wherever you like.',
          },
        }
        this.$toast.success(content)
      } else {
        // notify(this, 'Error', this.$t('failedCopy'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('failedCopy'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      }
    },
    async checkFunnel() {
      if (this.$store.getters.userInfo !== null) {
        try {
          const funnel = this.$store.getters.userInfo.funnel
          if (!funnel || funnel === '' || funnel === 'evaluator') {
            let result = await setUserFunnel(this, 'beginner')
            this.$store.commit('setUserInfo', result)

            this.$store.dispatch('setFirebaseLog', {
              eventName: 'funnel_beginner',
              eventParam: {
                createdAt: Date.now(),
                methodType: 'share_meeting',
              },
            })
          }
        } catch (e) {
          console.log()
        }
      }
    },
    async createShareUrl() {
      let title = this.mtInfo.mtTopic
      let imgUrl = this.mtInfo.mtThumbsUrl
      let routePayload = {
        name: 'ChannelMeetingShare',
        params: {
          wsDomain: this.$route.params['wsDomain'],
          chId: this.computedSelectedCh['chId'] ? this.computedSelectedCh['chId'].replace('CH:', '') : '',
          mtId: this.$route.params['mtId'],
        },
      }
      let linkUrl = location.origin + this.$router.resolve(routePayload).href
      let content = ''
      if (this.clipValue) {
        content = this.currentClip.clipNote
        if (this.currentClip.clipThumbsUrl) imgUrl = this.currentClip.clipThumbsUrl
        linkUrl += '?clipId=' + this.currentClip.clipId
      }

      // 공유 URL 생성 // TODO: fallbackUrl은 나중에 추가
      let copyUrl = await getShareUrl(this, title, content, imgUrl, linkUrl)
      this.path = copyUrl.shortLink
    },
    selectSection(index) {
      this.$store.dispatch('setSectionIndex', index)
      this.dialog = false
    },
    async setMtUpdate(updateEnded) {
      try {
        this.isEndedLoading = updateEnded
        let result = await setMtUpdate(
          this,
          this.$store.getters.selectedWsInfo ? this.$store.getters.selectedWsInfo.wsId : this.selectedCh.wsId,
          this.mtInfo.mtId,
          this.mtInfo.mtTopic,
          this.mtInfo.mtHashTag,
          updateEnded ? !this.isEnded : undefined
        )
        this.isEnded = result.isEnded

        // if (this.followUpItemList.length > 0 && this.followUpItemList !== undefined) {
        //   this.deleteFollowUp()
        // } else return
      } catch (error) {
        console.log(error)
      } finally {
        await this.$store.dispatch('setIsLoading', false)
        this.isEndedLoading = false
      }
    },
    ...mapActions(['setSignOut']),
    onScroll(e) {
      let target = e.target
      const scrollPercentage =
        target.scrollTop === 0 ? 0 : (100 * (target.scrollTop + target.clientHeight)) / target.scrollHeight
      this.isBottom = scrollPercentage >= 97
    },

    openDialog(type) {
      if (type === 'Setting') {
        this.settingVisible = true
      } else if (type === 'Share') {
        this.isShareDialog = true
      } else if (type === 'MoveToMeeting') {
        this.isMoveToDialog = true
      } else if (type === 'Delete') {
        this.isMeetingDeleteDialog = true
      } else if (type === 'EditName') {
        this.isEditnameDialog = true
      } else if (type === 'Slot') {
        this.$emit('openSlot', 'Slot')
      } else if (type === 'Manage') {
        this.$emit('openManage', 'Manage')
      } else if (type === 'Leave') {
        this.$emit('openDialog', 'Leave')
      }
    },
    closeDialog(val) {
      if (val === 'Setting') {
        this.settingVisible = false
        this.settingMenuType = ''
      } else if (val === 'Share') {
        this.isShareDialog = false
      } else if (val === 'MoveToMeeting') {
        this.isMoveToDialog = false
      } else if (val === 'Delete') {
        this.isMeetingDeleteDialog = false
      } else if (val === 'EditName') {
        this.isEditnameDialog = false
      }
    },
    async getNotiList(listType) {
      try {
        this.isGetNoti = true
        let result = await getNotiList(this, this.$store.getters.selectedWsInfo.wsId, listType, this.lastKey)
        if (result !== undefined && result !== null) {
          this.notiList = this.notiList.concat(result.notiList)
          if (result.lastKey !== undefined && result.lastKey !== null) this.lastKey = result.lastKey
          else this.isFinish = true
        }
      } catch (err) {
        console.log(err)
      } finally {
        this.isGetNoti = false
      }
    },
    bottomVisible() {
      const scrollY = window.scrollY
      const visible = document.documentElement.clientHeight
      const pageHeight = document.documentElement.scrollHeight
      const bottomOfPage = visible + scrollY >= pageHeight
      return bottomOfPage || pageHeight < visible
    },
    movePage(notiInfo) {
      let routePayload = {
        name: 'ChannelMeetingShare',
        params: {
          wsDomain: this.$route.params['wsDomain'],
          chId: this.computedSelectedCh['chId'] ? this.computedSelectedCh['chId'].replace('CH:', '') : '',
          mtId: notiInfo.mtId,
        },
      }
      let path = this.$router.resolve(routePayload).href
      // switch (notiInfo.notiType) {
      //   case 'createMt':
      //     break
      //   case 'createClip':
      //     path = path + `?clipId=${notiInfo.clipId}`
      //     break
      //   case 'watchClip':
      //     path = path + `?clipId=${notiInfo.clipId}`
      //     break
      //   case 'followUp':
      //     path + `?clipId=${notiInfo.clipId}`
      //     break
      //   case 'requestFollowUp':
      //     break
      //   case 'responseFollowUp':
      //     break
      //   case 'mention':
      //     break
      //   case 'createComment':
      //     break
      // }
      if (notiInfo && notiInfo['clipId'] && notiInfo['clipId'] !== '') path = `${path}?clipId=${notiInfo.clipId}`
      location.href = path
    },
    getSenderName(senderInfo) {
      return senderInfo && senderInfo.userDisplayName
        ? senderInfo.userDisplayName
        : senderInfo && senderInfo.userFullName
        ? senderInfo.userFullName
        : 'Anonymous'
    },
    getContentText(notiInfo) {
      try {
        let content
        let cmContent = ''
        let arg = [this.getSenderName(notiInfo.senderInfo), notiInfo.mtInfo.mtTopic]
        let userName = ''
        switch (notiInfo.notiType) {
          case 'createMt':
            content = this.$t('notiCreateMt')
            break
          case 'createClip':
            content = this.$t('notiCreateClip')
            break
          case 'watchClip':
            content = this.$t('notiWatchedClip')
            break
          case 'followUp':
            content = this.$t('notiRequestFollowUp')
            if (notiInfo['senderUid'] === '*') userName = 'Anyone'
            else userName = this.getSenderName(notiInfo.senderInfo)
            arg = [userName, notiInfo.mtInfo.mtTopic]
            break
          case 'willFollowUp':
            content = this.$t('notiResponseFollowUp')
            break
          case 'anHour':
            content = this.$t('notiAnHour')
            break
          case 'expirationFollowUp':
            content = this.$t('notiExpiration')
            arg = [notiInfo.mtInfo.mtTopic]
            break
          case 'mention':
            content = this.$t('notiMention')
            break
          case 'endedMt':
            content = this.$t('notiEndedMt')
            break
          case 'restartedMt':
            content = this.$t('notiRestartedMt')
            break
          case 'createComment':
            content = this.$t('notiCreateComment')
            if (notiInfo.cmContent && notiInfo.cmContent !== null)
              cmContent =
                notiInfo.cmContent.length > 30 ? notiInfo.cmContent.substring(0, 30) + '...' : notiInfo.cmContent

            arg = [this.getSenderName(notiInfo.senderInfo), cmContent, notiInfo.mtInfo.mtTopic]
            break
        }
        return format(content, arg)
      } catch (err) {
        console.log(err)
      }
    },
    calCreateAt(val) {
      return this.$day.duration(this.$day().diff(val)).humanize() + ' ago '
    },
    addTag() {
      // let valid = true
      let isTagDuplicate = false
      let mtHashTagArray = this.mtInfo.mtHashTag
      let newTag = this.newTag

      if (!newTag) {
        this.isAddTag = false
      } else {
        mtHashTagArray.forEach((tag) => {
          if (tag === newTag) {
            isTagDuplicate = true
            // notify(this, 'Error', 'Tag already exists.', 'error')
            const content = {
              component: Toast,
              props: {
                msg: 'Tag already exists.',
                // submsg: '',
              },
            }
            this.$toast.error(content)
          }
        })

        if (!isTagDuplicate && newTag.length < 25) {
          mtHashTagArray.push(newTag)
          this.newTag = ''
          this.setMtUpdate()
        } else if (!isTagDuplicate && newTag.length > 25) {
          // notify(this, 'Error', 'Tag characters must be less than 25 characters', 'error')
          const content = {
            component: Toast,
            props: {
              msg: 'Tag characters must be less than 25 characters',
              // submsg: '',
            },
          }
          this.$toast.error(content)
        }
      }
    },
    deleteTag(index) {
      if (this.isMtOrganizer) {
        this.mtInfo.mtHashTag.splice(index, 1)
        this.setMtUpdate()
      }
    },
    outFocus() {
      if (this.mtCreatorInfo && this.userInfo && this.mtCreatorInfo.userId === this.userInfo.userId) this.setMtUpdate()
      this.$refs.txt.blur()
      this.titleTooltip = true
      // let titleElement = document.getElementById('txt')
      // let isFocused = document.activeElement === titleElement

      // if (!this.mtInfo.mtTopic) {
      //   this.mtInfo.mtTopic =
      //     this.mtCreatorInfo.userDisplayName + this.$t('firstMeetingTopic') ||
      //     this.mtCreatorInfo.userFullName + this.$t('firstMeetingTopic')
      // }
      this.resize()
    },
    isEmptyObj(obj) {
      if (obj.constructor === Object && Object.keys(obj).length === 0) {
        return true
      }
      return false
    },
  },
  watch: {
    isOpened(val) {
      if (val && !this.isGetNoti) {
        this.notiList = []
        this.lastKey = null
        this.isFinish = false
        this.getNotiList('ALL')
      }
    },
    isBottom(isBottom) {
      if (isBottom && !this.isFinish && !this.isGetNoti) this.getNotiList('ALL')
    },
    isEnded(val) {
      this.mtInfo.isEnded = val
    },
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'chList',
      'selectedCh',
      'selectedWsInfo',
      'isMtOrganizer',
      'isWsManager',
      'isWsOwner',
      'currentMt',
      'wsClipCnt',
      'userName',
    ]),
    mtInfo() {
      return this.currentMt ?? {}
    },
    computedWsClipCnt() {
      return this.wsClipCnt ?? {}
    },
    // userWsClipCnt() {
    //   return this.wsClipCnt['wsClipCnt'] ?? 0
    // },
    // wsLimitCnt() {
    //   return this.wsClipCnt['freePlanWsClipLimit'] ?? 30
    // },
    userWsClipDuration() {
      return this.wsClipCnt['wsClipDuration'] ?? 0
    },
    wsLimitDuration() {
      return this.wsClipCnt['freePlanWsClipDurationLimit'] ?? 60 * 180
    },
    inboxFolderTitle() {
      let userName = ''
      if (
        this.computedSelectedCh &&
        this.computedSelectedCh['chCreatorInfo'] &&
        this.computedSelectedCh['chCreatorInfo']
      ) {
        userName =
          this.computedSelectedCh['chCreatorInfo']['userDisplayName'] ||
          this.computedSelectedCh['chCreatorInfo']['userFullName']
      }

      return userName.toLowerCase().charAt(userName.length - 1) === 's'
        ? `${userName}' Channel`
        : `${userName}'s Channel`
    },
    isSlackIntegrated() {
      let isIntegrated = false
      if (this.computedSelectedCh['integrationInfo'] && this.computedSelectedCh['integrationInfo'].length > 0) {
        for (let integration of this.computedSelectedCh['integrationInfo']) {
          if (integration['slackIntegration']) isIntegrated = true
        }
      }
      return isIntegrated
    },
    computedSelectedCh() {
      return this.selectedCh ?? {}
    },
    isSafari() {
      return isSafari()
    },
    attendeeList() {
      return this.mtInfo && this.mtInfo.mtAttendeeList ? this.mtInfo.mtAttendeeList : []
    },
    menuItems() {
      let items = []
      items.push({ title: 'Move to', type: 'MoveToMeeting' })
      return items
    },
    totalSectionList() {
      return this.$store.getters.totalSectionList
    },
    sectionIndex() {
      return this.$store.getters.sectionIndex
    },
    mtCreatorInfo() {
      return this.currentMt ? this.currentMt.mtCreatorInfo : {}
    },
    mtOrganizerUid() {
      return this.currentMt ? this.currentMt.mtOrganizerUid : ''
    },
    stId() {
      if (
        this.totalSectionList !== undefined &&
        this.totalSectionList !== null &&
        this.totalSectionList.length > 0 &&
        this.sectionIndex !== undefined &&
        this.sectionIndex !== null &&
        this.sectionIndex >= 0
      ) {
        return this.totalSectionList[this.sectionIndex].stId
      }
      return undefined
    },
    // followUpItemList() {
    //   if (
    //     this.totalSectionList !== undefined &&
    //     this.totalSectionList !== null &&
    //     this.totalSectionList.length > 0 &&
    //     this.sectionIndex !== undefined &&
    //     this.sectionIndex !== null &&
    //     this.sectionIndex >= 0
    //   ) {
    //     return this.totalSectionList.filter((totalSection) => {
    //       return totalSection.followUpItem
    //     })
    //     // return this.totalSectionList[this.sectionIndex].followUpItem
    //   }
    //   return {}
    // },
    isMobile() {
      return isMobile()
    },

    isPublic() {
      return this.mtInfo.isPublic
    },
    isNotiEmpty() {
      return !this.notiList || this.notiList === null || this.notiList.length <= 0
    },
    title() {
      if (this.mtPermission) {
        let chType

        if (this.mtPermission === 'P') chType = 'private'
        else if (this.mtPermission === 'W') chType = 'workspace'

        let currentCh = chType
          ? this.chList[chType].find((item) => item['chId'].replace('CH:', '') === this.$route.params.chId)
          : undefined
        return currentCh ? currentCh['chName'] : ''
      } else return ''
    },
    folder() {
      // TODO: i18n 적용 필요
      if (this.mtPermission === 'P') return 'Private'
      else if (this.mtPermission === 'W') return this.$t('teamChannelTitle')
      else if (this.mtPermission === 'I') return 'Inbox'
      else if (this.mtPermission === 'A') return 'Assigned'
      else return ''
    },
    mtPermission() {
      if (this.$route.name.indexOf('Inbox') > -1) return 'I'
      if (this.$route.name.indexOf('Assigned') > -1) return 'A'
      if (this.$route.name.indexOf('Share') === -1) return this.computedSelectedCh['chType'] ?? ''
      if (!this.mtInfo) return ''

      return this.mtInfo.mtPermission.charAt(0).toUpperCase()
    },
    isSectionMt() {
      return this.mtInfo.mtType === 'topic'
    },
  },
}
</script>

<style>
/* .v-app-bar.v-app-bar--fixed {
  z-index: 199;
} */
.label-end,
.label-end-dialog {
  display: inline-block;
  padding: 3px 7px;
  margin-right: 8px;
  border-radius: 8px;
  background-color: rgb(26, 39, 46);
  font-size: 13px;
  font-weight: 700;
  color: #25c685;
  vertical-align: middle;
}
.label-end-dialog {
  position: absolute;
  top: -40px;
  left: 0px;
  font-size: 15px;
  padding: 5px 9px;
  z-index: 9999;
}
.el-button--blue {
  background-color: #0062ff !important;
  color: white !important;
  border-color: #0062ff !important;
  margin-right: 0rem !important;
}
.underline {
  text-decoration: underline;
}
.wrap-text {
  -webkit-line-clamp: unset !important;
  white-space: normal !important;
  font-size: 14px;
  word-break: break-all;
}
.alarm-title {
  line-height: 1.3 !important;
}
.alarm-desc {
  font-size: 12px;
}
.v-menu__content {
  border-radius: 5px !important;
  background: #31434f;
  z-index: 215 !important;
}
.noti-empty {
  margin-top: 120px;
  margin-bottom: 100px;
  text-align: center;
  align-self: center;
  align-items: center;
}
.meeting-title {
  font-size: 18px;
  color: #eee;
  transition: all 0.3s;
  vertical-align: middle;
}
.meeting-untitle {
  font-size: 18px;
  color: #96a7af;
  transition: all 0.3s;
}
.meeting-title:hover {
  color: #25c685;
  transition: all 0.3s;
}
.txtf-meeting-title {
  font-size: 20px;
  font-weight: bold;
  cursor: text;
}
.txtf-meeting-title-organizer #txt {
  cursor: pointer;
  transition: all 0.3s;
}
.txtf-meeting-title input {
  position: relative;
}
.txtf-meeting-title.in-dialog {
  font-size: 40px;
}
@media (max-width: 1263px) {
  /* .txtf-meeting-title {
  } */
  .txtf-meeting-title .v-input__control > .v-input__slot {
    font-size: 20px;
    padding: 0 5px 0 0 !important;
  }
  .txtf-meeting-title.in-dialog {
    font-size: 20px;
  }
  .v-icon {
    font-size: 22px !important;
  }
  .menu-noti .v-avatar {
    width: 25px !important;
    min-width: 25px !important;
    height: 25px !important;
  }
}
.txtf-meeting-title input::placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}
.txtf-meeting-title .v-input__slot {
  color: white !important;
  background: transparent !important;
}
.section-title-in-dialog {
  display: inline-block;
  color: white;
  font-size: 25px;
  cursor: pointer;
}
@media (max-width: 1263px) {
  .section-title-in-dialog {
    font-size: 16px;
  }
}
.v-input input {
  color: #ffffff;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-height: 50px !important;
}
.v-tooltip {
  z-index: 200;
}
.v-tooltip__content {
  font-size: 12px !important;
  opacity: 1;
}
.el-input__inner {
  border-radius: 12px !important;
  cursor: text;
}
/* .container-avatar {
  border: 1px solid #96a7af;
  border-radius: 5px;
  padding: 2px !important;
} */
.avatar-bg {
  content: '';
  position: absolute;
  border-radius: 50%;
  top: 0px;
  left: 0px;
  width: calc(100%) !important;
  height: calc(100%) !important;
  background-color: white;
  z-index: 0;
}
#txt {
  border: none;
  font-size: 15px;
  /* min-width: 150px; */
  max-width: calc(100vw - 700px);
  font-weight: 500;
  /* cursor: text; */
  white-space: pre;
}

#txt:focus-visible {
  outline: none;
}

#hide {
  border: none;
  position: absolute;
  top: -100px;
  font-size: 15px;
  height: 0;
  font-weight: 500;
  white-space: pre;
  /* cursor: text; */
}
@media (max-width: 1263px) {
  #txt {
    font-size: 15px;
    max-width: calc(100vw - 600px);
  }
  #hide {
    font-size: 15px;
  }
}
@media (max-width: 959px) {
  #txt {
    max-width: calc(100vw - 400px);
  }
}
@media (max-width: 700px) {
  #txt {
    max-width: calc(100vw - 200px);
  }
}
@media (max-width: 600px) {
  #txt {
    font-size: 13px;
    font-weight: 500;
    padding: 0 5px 0 0 !important;
  }
}
/* .arrowdown:hover {
  color: #25c685;
} */
#header-btn-dropdown {
  opacity: 0;
}
@media (max-width: 960px) {
  .v-toolbar__content,
  .v-toolbar__extension {
    padding: 4px 12px;
  }
}
.clip-cnt {
  display: inline-block;
  font-size: 13px;
  font-weight: 500;
  color: #bbb;
  /* background-color: rgb(49, 67, 79); */
  border-radius: 5px;
  padding: 7px 10px;
  margin: 1px 5px 0 0px;
}
.clip-cnt div {
  display: inline-block;
}
@media (max-width: 959px) {
  .clip-cnt {
    margin: 0 0 0 10px;
  }
}
.btn-upgrade {
  color: #27cd8b !important;
  border: 1px solid #27cd8b;
  height: 32px !important;
  background-color: #1a272e !important;
  border-radius: 10px;
  margin-top: 2px;
}
.btn-upgrade span {
  font-size: 12px !important;
}
.avatar-bg {
  content: '';
  position: absolute;
  border-radius: 50%;
  top: 0px;
  left: 0px;
  width: calc(100%) !important;
  height: calc(100%) !important;
  background-color: white;
  z-index: 0;
}
</style>
